"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Legend = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _styles = require("@mui/material/styles");
var _Box = _interopRequireDefault(require("@mui/material/Box"));
var _reactI18next = require("react-i18next");
var _LinearScale = _interopRequireDefault(require("@mui/icons-material/LinearScale"));
var _Rectangle = _interopRequireDefault(require("@mui/icons-material/Rectangle"));
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
var Legend = function Legend(_ref) {
  var payload = _ref.payload,
    chartHeight = _ref.chartHeight;
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  var theme = (0, _styles.useTheme)();
  var ref = (0, _react.useCallback)(function (node) {
    if (node !== null) {
      node.parentElement.style.position = 'relative';
      node.parentElement.style.bottom = "".concat(chartHeight + 2, "px");
      node.parentElement.style.top = 'auto';
    }
  });
  var getColor = function getColor(key) {
    var color;
    switch (key) {
      case 'minimum':
        color = theme.palette.warning.light;
        break;
      case 'modal':
        color = theme.palette.info.dark;
        break;
      case 'maximum':
        color = theme.palette.success.dark;
        break;
      default:
        color = theme.palette.secondary.dark;
        break;
    }
    return color;
  };
  var renderShape = function renderShape(_ref2) {
    var key = _ref2.dataKey;
    switch (key) {
      case 'maximum':
        return /*#__PURE__*/_react.default.createElement(_Rectangle.default, {
          fontSize: "small",
          sx: {
            color: theme.palette.success.main
          }
        });
      default:
        return /*#__PURE__*/_react.default.createElement(_LinearScale.default, {
          fontSize: "small",
          sx: {
            color: getColor(key)
          }
        });
    }
  };
  return /*#__PURE__*/_react.default.createElement(_Box.default, {
    ref: ref,
    component: "ul",
    sx: {
      display: 'flex',
      pl: 0,
      m: 0,
      justifyContent: 'center'
    }
  }, ['maximum', 'minimum', 'modal', 'arrivals'].map(function (key) {
    var _ref3;
    var elem = payload.find(function (e) {
      return e.value === key;
    });
    return /*#__PURE__*/_react.default.createElement("li", {
      key: elem.value,
      style: (_ref3 = {
        listStyle: 'none',
        color: elem.stroke,
        display: 'flex',
        alignItems: 'center'
      }, (0, _defineProperty2.default)(_ref3, "color", getColor(elem.value)), (0, _defineProperty2.default)(_ref3, "fontWeight", 'bold'), _ref3)
    }, renderShape(elem), /*#__PURE__*/_react.default.createElement(_Typography.default, {
      variant: "body1"
    }, " ", t(elem.value), " "));
  }));
};
exports.Legend = Legend;